<template>
  <loading-cube v-if="loading"/>
  <div v-else>
    <details ref="location_data.location_id">
      <summary @click="handleSummaryClick">
        {{ getSummaryLocationName() }}
          <span v-if="this.new_ts_sites?.length > 0" class="tag" v-bind:class="getLocationStatusClass()">{{ getLocationStatusText() }}</span>
          <span v-else class="tag" v-bind:class="getLocationStatusClass()"></span>

        <span v-if="getLocationExpiring()" class="locationCcoExpiring">
          Site order due to expire contact {{ company_name }} today
        </span>
      </summary>

      <genericLoadingCube v-if="loading" :loadingMessage="loadingMessage"></genericLoadingCube>

      <div v-if="timesheetAuthorisation && !loading" class="expanded-contents">
          <h2>Totals</h2>
          <div class="totals">
            <div class="row">
              <div class="col-md-6">
                <table>
                  <tr>
                    <th><i class="fas fa-hard-hat"></i> Workers
                      <span v-if="isSubmitting">Submitted</span>
                      <span v-if="isAuthorising">Authorised</span>
                    </th>
                    <td>{{ getSubmittedWorkers(timesheetAuthorisation) }}/{{ getTotalWorkers(timesheetAuthorisation) }}
                    </td>
                  </tr>
                  <tr v-if="isPayrollEnabled && this.$parent.isNotForemanRole()">
                    <th><i class="fas fa-pound-sign"></i> Gross Additions &amp; Deductions</th>
                    <td>{{ sumOfTotalBeforeAdditionsAndDeductions(timesheetAuthorisation) | currency }}</td>
                  </tr>
                  <tr v-if="isPayrollEnabled && this.$parent.isNotForemanRole()">
                    <th><i class="fas fa-percent"></i> Retention Total</th>
                    <td>{{ sumOfReleaseRetentionAmount(timesheetAuthorisation) | currency }}</td>
                  </tr>
                  <tr v-if="this.$parent.isNotForemanRole()">
                    <th><i class="fas fa-file-invoice-dollar"></i> Invoice Total</th>
                    <td>{{ sumOfInvoiceTotal(timesheetAuthorisation) | currency }}</td>
                  </tr>
                </table>
              </div>
              <div class="col-md-6" v-if="isPayrollEnabled">
                <table>
                  <tr>
                    <th><i class="fa fa-angle-up" aria-hidden="true"></i>
                      Pre Tax Additions Total
                    </th>
                    <td>{{ sumOfPreTaxAdditionsAmount(timesheetAuthorisation) | currency }}</td>
                  </tr>
                  <tr>
                    <th><i class="fa fa-angle-double-up" aria-hidden="true"></i>
                      Post Tax Additions Total
                    </th>
                    <td>{{ sumOfPostTaxAdditionsAmount(timesheetAuthorisation) | currency }}</td>
                  </tr>
                  <tr>
                    <th><i class="fa fa-angle-down" aria-hidden="true"></i>
                      Pre Tax Deductions Total
                    </th>
                    <td>{{ sumOfPreTaxDeductionsAmount(timesheetAuthorisation) | currency }}</td>
                  </tr>
                  <tr>
                    <th><i class="fa fa-angle-double-down" aria-hidden="true"></i>
                      Post Tax Deductions Total
                    </th>
                    <td>{{ sumOfPostTaxDeductionsAmount(timesheetAuthorisation) | currency }}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>

          <hr />

          <h2>Timesheets</h2>
          <div class="timesheet_assignment" v-if="isPayrollEnabled && !allApproved()">
            <div class="ts_assignment_button">
              <button class="btn orcaBtn"
                @click.prevent="show_ts_assign_worker_modal(timesheetAuthorisation, getLocationName(timesheetAuthorisation))"><i
                  class="fas fa-plus"></i> Assign Worker
              </button>
            </div>
            <div class="ts_assignment_explainer">If one of your workers assigned to another site is missing from this
              site's
              timesheet, use this button to assign them to this
              location.<br>On making this change the current state of the timesheet will be saved and this page will
              reload.
            </div>
          </div>

          <div class="timesheet-entries">
            <table class="table">
              <thead>
                <tr>
                  <th>Full name<span class="d-block" style="font-size: 0.75rem;color: #999999;">Ref Number</span></th>
                  <th v-if="isPayrollEnabled"></th>
                  <th>Job Title</th>
                  <th v-if="isPayrollEnabled">Pay/Rate Type</th>
                  <th v-if="isPayrollEnabled && this.$parent.isNotForemanRole()">Pay Rate</th>
                  <th v-if="this.$parent.isNotForemanRole()">Charge Rate</th>
                  <th class="rotate" v-for="(day, index) in week" :style="zIndexReverse(week.length, index)">
                    <div class="capsule">
                      <span>{{ day }}</span>
                    </div>
                  </th>
                  <th v-if="timesheetAuthorisation.order_jobs[0].geotech_enabled == 1">GEO Tech</th>
                  <th v-if="isPayrollEnabled">Invoice</th>
                  <th>Total Units</th>
                  <th v-if="isPayrollEnabled && this.$parent.isNotForemanRole()" style="min-width: 125px;">Total Before
                    additions &amp; deductions</th>
                  <th v-if="isPayrollEnabled && this.$parent.isNotForemanRole() && showRetention()">Release Retention
                    (Percentage)</th>
                  <th v-if="isPayrollEnabled && this.$parent.isNotForemanRole() && showRetention()">Retention Amount
                  </th>
                  <th v-if="isPayrollEnabled">Pre-Tax Addition/Description</th>
                  <th v-if="isPayrollEnabled">Post-Tax Addition/Description</th>
                  <th v-if="isPayrollEnabled">Pre-Tax Deduction/Description</th>
                  <th v-if="isPayrollEnabled">Post-Tax Deduction/Description</th>
                  <th v-if="this.$parent.isNotForemanRole()">Invoice Total</th>
                  <th>Back Next Week</th>
                  <th>With</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(timesheetRecord, tr_index) in timesheetAuthorisation.ts_records">
                  <tr :class="timesheetStatusClass(timesheetRecord)">
                    <th>
                      <span class="d-block" style="font-size: 0.75rem;color: #999999;"
                        v-if="isPayrollEnabled && (timesheetRecord.assignment.order_job.order.order_type === 'Payroll - PAYE' || timesheetRecord.assignment.order_job.order.order_type === 'Temporary (PAYE)')">PAYE
                        WORKER</span>
                      <strong>{{ getWorkerNameSurname(timesheetRecord) }}</strong>
                      <span class="d-block" style="font-size: 0.75rem;color: #999999;">{{
                        getReferenceNumber(timesheetRecord) }}</span>
                      <span class="d-block" style="font-size: 0.75rem;" v-html="getGangMember(timesheetRecord)"></span>
                    </th>
                    <td v-if="isPayrollEnabled">
                      <button v-show="is_invoice_total_zero(timesheetRecord) && !allApproved()"
                        class="btn orcaBtn sm-btn"
                        @click.prevent="show_ts_rates_worker_modal(timesheetRecord, timesheetAuthorisation)"
                        title="Change Workers Pay Rate"><i class="fas fa-people-arrows"></i></button>
                    </td>
                    <td>{{ getWorkerJobTitle(timesheetRecord) }}</td>
                    <td v-if="isPayrollEnabled">{{ getWorkerPayRateType(timesheetRecord) }}</td>
                    <td v-if="isPayrollEnabled && $parent.isNotForemanRole()"><strong>{{
                      timesheetRecord.assignment.position_rate.pay_amount | currency }}</strong></td>
                    <td v-if="$parent.isNotForemanRole()"><strong>{{ getWorkerPayRateAdminFeeAmount(timesheetRecord) }}
                      </strong></td>
                    <td class="week" v-for="(day, index) in week">
                      <input type="text" list="abscense" :disabled="!isAuthorisedToEdit(timesheetRecord)"
                        :id="0 + '_' + tr_index + '_' + index" style="width: 30px;"
                        v-model.number="timesheetRecord.week[index]" @focus="dayFocus($event)"
                        :class="inputClass(timesheetRecord.timesheet_pay[index].absence_type)"
                        @focusout="dayFocusOut($event)" @change="changeTimesheetDay(tr_index, index, timesheetRecord)">
                      <div class="d-flex justify-content-center">

                        <h4>
                          <span style="cursor: pointer;" class="badge badge-light ml-1 mr-1" title="Sick Day"
                            @click="setAbsence('S', index, tr_index)">
                            S
                          </span>
                        </h4>

                        <h4>
                          <span style="cursor: pointer;" class="badge badge-light" title="Miscellaneous"
                            @click="setAbsence('M', index, tr_index)">
                            M
                          </span>
                        </h4>

                        <h4>
                          <span style="cursor: pointer;" class="badge badge-light ml-1 mr-1" title="Holiday"
                            @click="setAbsence('H', index, tr_index)">
                            H
                          </span>
                        </h4>
                      </div>

                      <div class="d-flex justify-content-center mt-1" style="height:22px;">
                        <span
                          v-show="get_timesheet_worker_invoice_details_description(timesheetRecord.timesheet_pay[index])"
                          style="cursor: pointer;width:50%;font-size: 100%;" class="badge badge-light ml-1 mr-1"
                          v-b-popover.hover="{ title: 'Description', content: get_timesheet_worker_invoice_details_description(timesheetRecord.timesheet_pay[index]), trigger: 'hover focus click' }">
                          <i class="fas fa-comment-dots"></i>
                        </span>
                      </div>

                    </td>

                    <td v-if="timesheetAuthorisation.order_jobs[0].geotech_enabled == 1">
                      <button class="btn orcaBtn sm-btn" @click="getGeoTech(timesheetRecord)" title="Get from Geo Tech">
                        <i class="fas fa-location-arrow"></i>
                      </button>
                    </td>
                    <td v-if="isPayrollEnabled">
                      <span v-if="isInvoiceAvailable(timesheetRecord)" class="invoice-summary"
                        @click="showInvoiceSummary(timesheetRecord)">
                        <i class="fas fa-file-invoice"></i>
                      </span>
                    </td>
                    <td>{{ getTotalUnits(timesheetRecord) | decimal2 }}</td>
                    <td v-if="isPayrollEnabled && $parent.isNotForemanRole()">{{
                      getTotalBeforeAdditionsAndDeductions(timesheetRecord) | currency }}</td>
                    <td v-if="isPayrollEnabled && $parent.isNotForemanRole() && showRetention()">
                      <input :disabled="!isAuthorisedToEdit(timesheetRecord)" type="checkbox"
                        v-model="timesheetRecord.retention_released" @change="changeTimesheetValues(timesheetRecord)" />
                      {{ getReleaseRetentionPercentage(timesheetRecord) | percentage }}
                    </td>
                    <td v-if="isPayrollEnabled && $parent.isNotForemanRole() && showRetention()">{{
                      getReleaseRetentionAmount(timesheetRecord) | currency }}</td>
                    <td v-if="isPayrollEnabled">
                      <div class="additions-and-deductions-manager">
                        <div class="selections">
                          <div class="selection" v-for="selection in getPreTaxAdditions(timesheetRecord)">
                            <input :disabled="!isAuthorisedToEdit(timesheetRecord)"
                              @change="changeAdditionAndDeductionValue(selection); changeTimesheetValues(timesheetRecord)"
                              type="text" v-model.number="selection.amount" @focus="$event.target.select()">
                            <select :disabled="!isAuthorisedToEdit(timesheetRecord)" v-model="selection.desc"
                              @change="closePreview(); forceUpdate()" @focus="closePreview(); forceUpdate()"
                              @blur="closePreview(); forceUpdate()">
                              <option v-for="option in timesheetPreTaxAdditionsOptions" :value="option">{{ option.value
                                }}
                              </option>
                              <!--                            <option v-for="option in timesheetPreTaxAdditionsOptionsAll" :value="option" disabled>{{ option.value }}</option>-->
                            </select>
                            <span v-if="isAuthorisedToEdit(timesheetRecord)" class="remove-selection"
                              @click="removePreTaxAddition(selection, timesheetRecord)">
                              <i class="fas fa-trash-alt"></i>
                            </span>
                          </div>
                        </div>
                        <span v-if="isAuthorisedToEdit(timesheetRecord)" class="add-selection"
                          @click="addPreTaxAddition(timesheetRecord)">Pre-Tax Addition +</span>
                      </div>
                    </td>
                    <td v-if="isPayrollEnabled">
                      <div class="additions-and-deductions-manager">
                        <div class="selections">
                          <div class="selection" v-for="selection in getPostTaxAdditions(timesheetRecord)">
                            <input :disabled="!isAuthorisedToEdit(timesheetRecord)"
                              @change="changeAdditionAndDeductionValue(selection); changeTimesheetValues(timesheetRecord)"
                              type="text" v-model.number="selection.amount" @focus="$event.target.select()">
                            <select :disabled="!isAuthorisedToEdit(timesheetRecord)" v-model="selection.desc"
                              @change="closePreview(); forceUpdate()" @focus="closePreview(); forceUpdate()"
                              @blur="closePreview(); forceUpdate()">
                              <option v-for="option in timesheetPostTaxAdditionsOptions" :value="option">{{ option.value
                                }}
                              </option>
                              <!--                            <option v-for="option in timesheetPostTaxAdditionsOptionsAll" :value="option" disabled>{{ option.value }}</option>-->
                            </select>
                            <span v-if="isAuthorisedToEdit(timesheetRecord)" class="remove-selection"
                              @click="removePostTaxAddition(selection, timesheetRecord)">
                              <i class="fas fa-trash-alt"></i>
                            </span>
                          </div>
                        </div>
                        <span v-if="isAuthorisedToEdit(timesheetRecord)" class="add-selection"
                          @click="addPostTaxAddition(timesheetRecord)">Post-Tax Addition +</span>
                      </div>
                    </td>
                    <td v-if="isPayrollEnabled">
                      <div class="additions-and-deductions-manager">
                        <div class="selections">
                          <div class="selection" v-for="selection in getPreTaxDeductions(timesheetRecord)">
                            <input :disabled="!isAuthorisedToEdit(timesheetRecord)"
                              @change="changeAdditionAndDeductionValue(selection); changeTimesheetValues(timesheetRecord)"
                              type="text" v-model.number="selection.amount" @focus="$event.target.select()">
                            <select :disabled="!isAuthorisedToEdit(timesheetRecord)" v-model="selection.desc"
                              @change="closePreview(); forceUpdate()" @focus="closePreview(); forceUpdate()"
                              @blur="closePreview(); forceUpdate()">
                              <option v-for="option in timesheetPreTaxDeductionsOptions" :value="option">{{ option.value
                                }}
                              </option>
                              <!--                            <option v-for="option in timesheetPreTaxDeductionsOptionsAll" :value="option" disabled>{{ option.value }}</option>-->
                            </select>
                            <span v-if="isAuthorisedToEdit(timesheetRecord)" class="remove-selection"
                              @click="removePreTaxDeduction(selection, timesheetRecord)">
                              <i class="fas fa-trash-alt"></i>
                            </span>
                          </div>
                        </div>
                        <span v-if="isAuthorisedToEdit(timesheetRecord)" class="add-selection"
                          @click="addPreTaxDeduction(timesheetRecord)">Pre-Tax Deduction +</span>
                      </div>
                    </td>
                    <td v-if="isPayrollEnabled">
                      <div class="additions-and-deductions-manager">
                        <div class="selections">
                          <div class="selection" v-for="selection in getPostTaxDeductions(timesheetRecord)">
                            <input :disabled="!isAuthorisedToEdit(timesheetRecord)"
                              @change="changeAdditionAndDeductionValue(selection); changeTimesheetValues(timesheetRecord)"
                              type="text" v-model.number="selection.amount" @focus="$event.target.select()">
                            <select :disabled="!isAuthorisedToEdit(timesheetRecord)" v-model="selection.desc"
                              @change="closePreview(); forceUpdate()" @focus="closePreview(); forceUpdate()"
                              @blur="closePreview(); forceUpdate()">
                              <option v-for="option in timesheetPostTaxDeductionsOptions" :value="option">{{
                                option.value
                                }}
                              </option>
                              <!--                            <option v-for="option in timesheetPostTaxDeductionsOptionsAll" :value="option" disabled>{{ option.value }}</option>-->
                            </select>
                            <span v-if="isAuthorisedToEdit(timesheetRecord)" class="remove-selection"
                              @click="removePostTaxDeduction(selection, timesheetRecord)">
                              <i class="fas fa-trash-alt"></i>
                            </span>
                          </div>
                        </div>
                        <span v-if="isAuthorisedToEdit(timesheetRecord)" class="add-selection"
                          @click="addPostTaxDeduction(timesheetRecord)">Post-Tax Deduction +</span>
                      </div>
                    </td>
                    <td v-if="$parent.isNotForemanRole()">{{ getInvoiceTotal(timesheetRecord) | currency }}</td>
                    <td>
                      <input type="checkbox" :disabled="!isAuthorisedToEdit(timesheetRecord)"
                        v-model="timesheetRecord.back_next_week" />
                    </td>
                    <td>{{ getAuthoriseWith(timesheetRecord) }}</td>
                  </tr>

                  <tr v-if="timesheetRecord.geoTechRow">
                    <th v-if="!timesheetRecord.geoTechPushed">Geo Tech Data</th>
                    <th v-if="timesheetRecord.geoTechPushed">Manual Data</th>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>

                    <td v-if="timesheetRecord.geoTechPushed" class="week"
                      v-for="(day, index) in timesheetRecord.savedManualInput">
                      <input readonly :disabled="!isAuthorisedToEdit(timesheetRecord)"
                        :id="0 + '_' + tr_index + '_' + index" type="text" style="width: 30px;"
                        v-model.number="timesheetRecord.savedManualInput[index]" @focus="dayFocus($event)"
                        @focusout="dayFocusOut($event)" @change="changeTimesheetDay(index, timesheetRecord)" />
                    </td>

                    <td v-if="timesheetRecord.geoTechPushed">
                      <button class="btn orcaBtn sm-btn" title="Push Manual Input"
                        @click="pushManualInput(timesheetRecord, tr_index)">
                        <i class="fas fa-hand-sparkles"></i>
                      </button>
                    </td>

                    <td v-if="!timesheetRecord.geoTechPushed" class="week"
                      v-for="(day, index) in timesheetRecord.geoTechWeek">
                      <input :id="0 + '_' + '_' + index" type="text" readonly
                        v-model="timesheetRecord.geoTechWeek[index]" style="width: 30px;" />
                    </td>

                    <td v-if="!timesheetRecord.geoTechPushed">
                      <button class="btn orcaBtn sm-btn" title="Push Geo"
                        @click="pushGeoTech(timesheetRecord, tr_index)">
                        <i class="fas fa-arrow-up"></i>
                      </button>
                    </td>

                    <td v-if="isPayrollEnabled" colspan="14"></td>
                  </tr>
                </template>

                <tr v-if="isPayrollEnabled && !allApproved()">
                  <th>
                    <button class="btn orcaBtn"
                      @click="show_ts_assign_worker_modal(timesheetAuthorisation, getLocationName(timesheetAuthorisation))">
                      <i class="fas fa-plus"></i> Assign
                    </button>
                  </th>
                  <td colspan="11">If one of your workers assigned to another site is missing from this site's
                    timesheet,
                    use
                    this button to assign them to this location.<br>On
                    making this change the current state of the timesheet will be saved and this page will reload.
                  </td>
                  <td v-if="isPayrollEnabled" colspan="14"></td>
                  <td v-else colspan="4"></td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <th><!-- First Name --></th>
                  <th v-if="isPayrollEnabled"><!-- Assignment Button --></th>
                  <th><!-- Job Title --></th>
                  <th v-if="isPayrollEnabled"><!-- Pay/Rate Type --></th>
                  <th v-if="isPayrollEnabled"></th>
                  <th></th>
                  <th v-for="(day, index) in week">
                    <span>{{ sumOfDays(timesheetAuthorisation, index) | decimal2 }}</span>
                  </th>
                  <th v-if="timesheetAuthorisation.order_jobs[0].geotech_enabled == 1"></th>
                  <th v-if="isPayrollEnabled"><!-- Invoice --></th>
                  <th>{{ sumOfTotalUnits(timesheetAuthorisation) | decimal2 }}<!-- Total Units --></th>
                  <th v-if="isPayrollEnabled">{{ sumOfTotalBeforeAdditionsAndDeductions(timesheetAuthorisation) |
                    currency
                    }}<!-- Total Before additions &amp; deductions --></th>
                  <th v-if="isPayrollEnabled"><!-- Release Retention (Percentage) --></th>
                  <th v-if="isPayrollEnabled">{{
                    sumOfReleaseRetentionAmount(timesheetAuthorisation) | currency
                    }}<!-- Retention Amount --></th>
                  <th v-if="isPayrollEnabled">{{ sumOfPreTaxAdditionsAmount(timesheetAuthorisation) | currency
                    }}<!-- Pre-Tax Addition/Description --></th>
                  <th v-if="isPayrollEnabled">{{ sumOfPostTaxAdditionsAmount(timesheetAuthorisation) | currency
                    }}<!-- Post-Tax Addition/Description --></th>
                  <th v-if="isPayrollEnabled">{{ sumOfPreTaxDeductionsAmount(timesheetAuthorisation) | currency
                    }}<!-- Pre-Tax Deduction/Description --></th>
                  <th v-if="isPayrollEnabled">{{ sumOfPostTaxDeductionsAmount(timesheetAuthorisation) | currency
                    }}<!-- Post-Tax Deduction/Description --></th>
                  <th>{{ sumOfInvoiceTotal(timesheetAuthorisation) | currency }}<!-- Invoice Total --></th>
                  <th><!-- Back Next Week --></th>
                  <th><!-- With --></th>
                  <th><!-- Submit --></th>
                </tr>
              </tfoot>
            </table>
          </div>

          <div>
            <hr />

            <h2>Key</h2>
            <h2>
              <span class="badge badge-danger hand" title="Sick Day" @click="setAbsence('S', index, tr_index)">
                Sick Day
              </span>
            </h2>

            <h2>
              <span class="badge badge-primary hand" title="Sick Day" @click="setAbsence('S', index, tr_index)">
                Miscellaneous
              </span>
            </h2>

            <h2>
              <span class="badge badge-warning hand" title="Holiday" @click="setAbsence('H', index, tr_index)">
                Holiday
              </span>
            </h2>

            <h5>* Please note this is for tracking purposes, not related to pay/wages</h5>

            <hr />
          </div>

          <p class="submit">
            <button v-if="canSaveButton(timesheetAuthorisation)"
              @click="saveAllWorkersInLocation(timesheetAuthorisation)" class="btn orcaBtn grey_bg mb-2">Save</button>
            <button @click="submitAllWorkersInLocation(timesheetAuthorisation)" class="btn orcaBtn">{{
              determineButtonText(timesheetAuthorisation) }}</button>
          </p>

          <!-- ALL OF THE BELOW ONLY SHOW IF PAYROLL ENABLED -->
          <div v-if="isPayrollEnabled" class="reminders">

            <hr />

            <h2>Reminders</h2>

            <button @click="toggleReminderInformation(timesheetAuthorisation)"
              class="btn orcaBtn sm_btn mb-3 float-right mt-0" style="margin-left: 15px;">
              Toggle Reminders
            </button>

            <p>Use reminders to add compliance notes to be dealt with now or in the future against any of your orders.
            </p>

            <div v-for="orderJob in timesheetAuthorisation.order_jobs"
              v-if="timesheetAuthorisation.showReminderInformation">
              <div class="row">
                <div class="col-md-3">
                  <strong>CCO Ref:</strong>
                  {{ getSummaryOrderRef(orderJob) }}
                </div>
                <div class="col-md-3">
                  <strong>Job Title:</strong>
                  {{ getSummaryJobTitle(orderJob) }}
                </div>
                <div class="col-md-6">
                  <strong>Supervisor name (Reports to) :</strong>
                  {{ getSummarySupervisorName(orderJob) }}
                </div>
              </div>
              <hr />
            </div>
          </div>

          <hr v-if="isPayrollEnabled" />

          <h2 v-if="isPayrollEnabled">Summary</h2>

          <div v-if="isPayrollEnabled" class="info">
            <button @click="toggleLocationInformation(timesheetAuthorisation)"
              class="btn orcaBtn sm_btn mb-3 float-right mt-0" style="margin-left: 15px;">
              Toggle Information
            </button>
            <p>Please click the show info button to display all the positions assigned to this location, this will then
              allow
              you to fill in information about works completed
              this pay period.</p>

            <div class="expanded" v-if="timesheetAuthorisation.showLocationInformation">
              <ul>
                <li v-for="orderJob in timesheetAuthorisation.order_jobs">

                  <div class="row">
                    <div class="col-md-3">
                      <strong>CCO Ref:</strong>
                      {{ getSummaryOrderRef(orderJob) }}
                    </div>
                    <div class="col-md-3">
                      <strong>Job Title:</strong>
                      {{ getSummaryJobTitle(orderJob) }}
                    </div>
                    <div class="col-md-6">
                      <strong>Supervisor name (Reports to) :</strong>
                      {{ getSummarySupervisorName(orderJob) }}
                    </div>
                  </div>

                  <hr />

                  <div class="entry">
                    <button class="btn orcaBtn sm_btn mb-3 mt-0 float-right" style="margin-left: 10px;"
                      @click="toggleOrderJobFields(orderJob)">
                      Toggle Fields
                    </button>

                    <p>If you wish to record information for completed works by the {{ getSummaryJobTitle(orderJob) }}'s
                      working on this site,
                      click the 'Toggle&nbsp;Fields' button to enter/view the details which are broken down by day.</p>

                    <div class="fields" v-if="orderJob.showFields">
                      <div v-for="log in orderJob.workLog">
                        <h5>{{ log.day }}</h5>
                        <textarea v-model="log.description"
                          :placeholder="'Add a description of works completed by ' + getSummaryJobTitle(orderJob) + '\'s'"></textarea>
                      </div>
                    </div>
                  </div>

                </li>
              </ul>
            </div>
          </div>
        <ts_assign_worker v-if="$store.state.client_timesheets.ts_assign_worker_modal"
            :order_jobs="timesheetAuthorisation.order_jobs" 
            :key="location_data.location_id"
            @reload-location-details="loadLocationDetails">
        </ts_assign_worker>
        <ts_rate_change v-if="$store.state.client_timesheets.ts_rate_change_modal" 
            @reload-location-details="loadLocationDetails">
        </ts_rate_change>
      </div>
    </details>
  </div>
</template>

<style>
.bg-red {
  background: #FFA9A9;
}

.bg-yellow {
  background: #FEFFA9;
}

.bg-blue {
  background: #A9FFFE;
}
</style>

<script>
import loadingCube from "loaders/record_loader";
import genericLoadingCube from "loaders/generic_record_loader";
import ts_assign_worker from "pages/clients/timesheets/modals/ts_assign_worker";
import ts_rate_change from "pages/clients/timesheets/modals/ts_rate_change";
import paginator from 'components/pages/paginator/paginator';

export default {
  name: "timesheet_location_submitter",
  props: ['location_data',
    'company_name',
    'submission_date',
    'timesheet_template_name',
    'company_id',
    'timesheet_cycle_id',
    'ms_opts',
    'new_ts_sites'
  ],
  components: {
    loadingCube,
    genericLoadingCube,
    ts_assign_worker,
    ts_rate_change,
    paginator
  },
  data() {
    return {
      // Loading State
      loadingMessage: 'Loading ...',
      loading: false,
      approved: [],
      // Props
      companyName: this.company_name,
      companyData: null,
      submissionDate: this.submission_date,

      // Flags
      isSubmitting: false,
      isAuthorising: false,
      isPayroll: false,
      isRecruitment: false,
      isPayrollEnabled: false,
      isRecruitmentEnabled: false,
      isTermsAgreedTo: false,
      showPreview: false,

      // Additions and Deductions
      timesheetPreTaxAdditionsOptions: this.ms_opts.pre_add,
      timesheetPostTaxAdditionsOptions: this.ms_opts.post_add,
      timesheetPreTaxDeductionsOptions: this.ms_opts.pre_ded,
      timesheetPostTaxDeductionsOptions: this.ms_opts.post_ded,

      // Timesheet Authorisations
      locationData: this.location_data,
      timesheetAuthorisations: [],
      timesheetAuthorisation: null,
      timesheetAuthorisationsPagination: {},
      invoiceAmountCheck: false,

      // Common Data
      week: [],
      workers: []
    }
  },
  async beforeMount() {
    await this.loadCompanyData();
    this.setFlags();
  },
  methods: {
    async getGeoTech(timesheetrecord) {
      // open or close geo tech
      this.$set(timesheetrecord, "geoTechRow", !timesheetrecord.geoTechRow);

      if (!timesheetrecord.geoTechRow) {
        this.forceUpdate();
        return;
      }

      // validation to try and make the get request
      try {
        const response = await axios.get(this.crmApiPath + `geo_tracking/get_week/${timesheetrecord.timesheet_pay[0].ts_record_id}/${timesheetrecord.worker_id}`);

        // updates to open the row
        timesheetrecord.geoTechWeek = response.data;
        this.$set(timesheetrecord, 'geoTechRow', true);
        this.forceUpdate();
      } catch (error) {
        console.error('Error fetching geo tech data:', error);
        this.$set(timesheetrecord, 'geoTechRow', false);
        this.forceUpdate();
      }
    },
    async handleSummaryClick() {
      if (this.timesheetAuthorisation) return;
      await this.loadLocationDetails();
    },
    getLocationData() {
        return axios.get(this.crmApiPath + 'timesheet_authorisation/client/location/' + this.$store.state.auth.me.contact_id, {
          params: {
            ts_submission_date: this.submissionDate.end_date,
            location_name: this.location_data.location_id
          }
        });
    },
    async fetchNewTSSites() {
      try {
        const { status, data } = await axios.get(
            `${this.crmApiPath}r2/client/timesheets/sites`,
            {
              params: { submission_date: this?.submissionDate?.end_date ?? "" },
              timeout: 15000,
              validateStatus: s => s >= 200 && s < 300
            }
        );

        if (status !== 200 || !data) {
          throw new Error(`Bad response: ${status}`);
        }

        this.new_ts_sites = Array.isArray(data.data) ? data.data : [];
        return true;
      } catch (err) {
        console.error("Could not fetch new sites:", err?.response?.status || err?.message || err);
        this.new_ts_sites = [];
        return false;
      }
    },
    async loadLocationDetails() {
      this.loading = true;
      this.loadingMessage = 'Loading ...';
      this.timesheetAuthorisations = [];
      this.timesheetAuthorisation = null;

      // always fetch sites first (swallow errors, keep flow async)
      // await this.fetchNewTSSites();

      // fully async/await, no try/catch
      const resp = await this.getLocationData();
      const data = resp?.data || null;

      if (data) {
        this.timesheetAuthorisations.push(data);
        this.timesheetAuthorisation = data;
        // if async, await; if not, no harm
        await this.prepareTimeSheetInformation();
      }

      this.loading = false;
      return !!data; // true if loaded, false otherwise
    },
    getSummaryLocationName() {
      if (this.location_data.alt_address_name) {
        return this.location_data.alt_address_name;
      }

      return this.location_data.short_site_name;
    },
    findSiteByShortName(name) {
      return this.new_ts_sites?.find(s => s.short_site_name === name) || null;
    },
    getLocationExpiring() {
      return this.location_data.ending_soon;
    },
    getLocationStatusClass() {
      if (this.location_data.auth_level >= 8) {
        return 'complete'
      }

      return 'default';
    },
    getLocationStatusText() {
      let newApiData = this.findSiteByShortName(this.location_data.short_site_name);

      if(newApiData) {
        if(newApiData.completed) {
          return 'Completed';
        }
        else{
          return 'In Progress';
        }
      }

      //fallback
      if (this.location_data.auth_level >= 8) {
        return 'Approved';
      }

      return 'Awaiting approval';
    },
    showRetention() {
      return this.companyData.default_retention_percentage > 0;
    },
    pushGeoTech(timesheetrecord, recordIndex) {
      // toggles push geotech
      this.$set(timesheetrecord, "geoTechPushed", true);

      // save current manual input
      this.$set(timesheetrecord, "savedManualInput", timesheetrecord.week);

      // push geotech into week
      this.$set(timesheetrecord, "week", timesheetrecord.geoTechWeek);

      this.resetAbsence(recordIndex);

      this.$emit('location-preview-reload');
      this.forceUpdate();
    },
    pushManualInput(timesheetrecord, recordIndex) {
      // toggles push geotech
      this.$set(timesheetrecord, "geoTechPushed", !timesheetrecord.geoTechPushed);

      // push saved manual input back into week
      this.$set(timesheetrecord, "week", timesheetrecord.savedManualInput);

      this.resetAbsence(recordIndex);

      this.$emit('location-preview-reload');
      this.forceUpdate();
    },

    dayFocus(event) {
      event.target.select()
      let element = document.getElementById(event.target.id)
      let closest_row = element.closest("tr")
      closest_row.classList.add('selected_row')
    },
    dayFocusOut(event) {
      let element = document.getElementById(event.target.id);
      let closest_row = element.closest("tr");
      closest_row.classList.remove('selected_row');
    },

    /***********************************************************************
     *  Prepare Timesheet Data for Component
     ***********************************************************************/
    prepareTimeSheetInformation() {
      // Sort the timesheet authorisations
      this.sortTimesheetAuthorisations();

      // Create the working week that the client uses
      this.createClientTimesheetWeek();

      // Create the list of unique workers regardless of locations
      this.createWorkersList();

      // Our raw JSON object needs additional fields to be populated which do not exist by default
      this.createAdditionalSubmissionFields();

      // If there is a previous save against this submission go through and populate the defaults
      this.prePopulateFromSaveSubmissions();
    },
    sortTimesheetAuthorisations() {
      this.timesheetAuthorisations.forEach(timesheetAuthorisation => {
        const leaders = [];
        const members = {};

        // Separate records into leaders and members
        timesheetAuthorisation.ts_records.forEach(record => {
          if (record.assignment.is_gang_leader) {
            leaders.push(record);
          } else {
            const leaderId = record.assignment.gang_leader_id;
            if (!members[leaderId]) {
              members[leaderId] = [];
            }
            members[leaderId].push(record);
          }
        });

        // Sort leaders alphabetically
        leaders.sort((a, b) => {
          const nameA = a.assignment.worker.person.surname.toLowerCase() + ' ' + a.assignment.worker.person.first_name.toLowerCase();
          const nameB = b.assignment.worker.person.surname.toLowerCase() + ' ' + b.assignment.worker.person.first_name.toLowerCase();
          if (nameA < nameB) return -1;
          if (nameA > nameB) return 1;
          return 0;
        });

        // Sort members alphabetically leader's group
        Object.keys(members).forEach(leaderId => {
          members[leaderId].sort((a, b) => {
            const nameA = a.assignment.worker.person.surname.toLowerCase() + ' ' + a.assignment.worker.person.first_name.toLowerCase();
            const nameB = b.assignment.worker.person.surname.toLowerCase() + ' ' + b.assignment.worker.person.first_name.toLowerCase();
            if (nameA < nameB) return -1;
            if (nameA > nameB) return 1;
            return 0;
          });
        });

        // Merge leaders and their members into a sorted list
        const sortedRecords = [];
        leaders.forEach(leader => {
          sortedRecords.push(leader);
          if (members[leader.assignment.worker.id]) {
            sortedRecords.push(...members[leader.assignment.worker.id]);
          }
        });

        // Add remaining records without a leader
        const noLeaderRecords = timesheetAuthorisation.ts_records.filter(record => !record.assignment.is_gang_leader && !record.assignment.gang_leader_id);
        noLeaderRecords.sort((a, b) => {
          const nameA = a.assignment.worker.person.surname.toLowerCase() + ' ' + a.assignment.worker.person.first_name.toLowerCase();
          const nameB = b.assignment.worker.person.surname.toLowerCase() + ' ' + b.assignment.worker.person.first_name.toLowerCase();
          if (nameA < nameB) return -1;
          if (nameA > nameB) return 1;
          return 0;
        });
        sortedRecords.push(...noLeaderRecords);

        timesheetAuthorisation.ts_records = sortedRecords;
      });
    },

    createClientTimesheetWeek() {
      // Find out the working week for this particular client
      this.week = [];

      if (this.timesheetAuthorisations.length > 0) {
        let exampleTimesheetAuthorisations = this.timesheetAuthorisations[0];

        // Only establish the working week for clients with timesheet records
        if (exampleTimesheetAuthorisations.ts_records.length > 0) {

          // Build up the week
          let exampleWeek = exampleTimesheetAuthorisations.ts_records[0].timesheet_pay;

          exampleWeek.forEach(day => {
            // Format the date for this client
            let week_format_day = this.$moment.utc(day.pay_date).format('dddd')
            if (this.timesheet_cycle_id === 1 || this.timesheet_cycle_id === 2) {
              week_format_day = this.$moment.utc(day.pay_date).format('ddd DD/MM/YYYY')
            }
            this.week.push(week_format_day);
          });
        }
      }
    },
    createWorkersList() {
      this.workers = [];
      let timesheetAuthorisations = this.timesheetAuthorisations;

      if (timesheetAuthorisations.length > 0) {
        timesheetAuthorisations.forEach(timesheetAuthorisation => {
          timesheetAuthorisation.ts_records.forEach(timesheetRecord => {
            let worker = timesheetRecord.assignment.worker;

            // Filter the existing array down to see if we have already found this worker
            let matchedWorkers = this.workers.filter(workerReference => {
              return workerReference.id === worker.id
            });

            // Only add to our array if the worker does not already appear in it
            if (matchedWorkers.length <= 0) {
              this.workers.push(worker);
            }
          });
        });
      }

      // Sort the workers by their full names alphabetically
      this.workers = this.workers.sort(function (a, b) {
        a = a.person.surname.toLowerCase() + ' ' + a.person.first_name.toLowerCase();
        b = b.person.surname.toLowerCase() + ' ' + b.person.first_name.toLowerCase();

        return (a < b) ? -1 : (a > b) ? 1 : 0;
      });

    },
    createAdditionalSubmissionFields() {
      // We need to build up additional fields and give them defaults to be used
      this.timesheetAuthorisations.forEach(timesheetAuthorisation => {

        timesheetAuthorisation.showLocationInformation = false;
        timesheetAuthorisation.showReminderInformation = false;

        // Timesheets
        timesheetAuthorisation.ts_records.forEach(timesheetRecord => {

          // GeoTech
          timesheetRecord.geoTechRow = false;
          timesheetRecord.geoTechPushed = false;
          timesheetRecord.geoTechWeek = [0, 0, 0, 0, 0, 0, 0];
          timesheetRecord.savedManualInput = [0, 0, 0, 0, 0, 0, 0];

          // Week
          timesheetRecord.week = [];
          this.week.forEach(day => {
            timesheetRecord.week.push(0);
          });

          // Total Units
          timesheetRecord.totalUnits = 0;

          // Additions and deductions
          timesheetRecord.preTaxAdditions = [];
          timesheetRecord.postTaxAdditions = [];
          timesheetRecord.preTaxDeductions = [];
          timesheetRecord.postTaxDeductions = [];
        });

        // Orders
        timesheetAuthorisation.order_jobs.forEach(orderJob => {
          orderJob.showFields = false;

          orderJob.workLog = [];
          this.week.forEach(day => {
            orderJob.workLog.push({
              day: day,
              description: null
            });
          });

        });
      });
    },
    prePopulateFromSaveSubmissions() {
      this.timesheetAuthorisations.forEach(timesheetAuthorisation => {

        // Timesheets
        timesheetAuthorisation.ts_records.forEach(timesheetRecord => {

          // Week
          this.week.forEach((day, index) => {
            this.setWorkerHours(timesheetRecord, index);
          });

          // Additions and Deductions
          timesheetRecord.timesheet_additions_deductions.forEach(additionsAndDeductions => {

            // Build the addition/deduction object
            let savedAdditionsAndDeduction = {
              "id": additionsAndDeductions.id,
              "ts_record_id": additionsAndDeductions.ts_record_id,
              "amount": additionsAndDeductions.amount,
              "desc": additionsAndDeductions.desc
            };

            // Populate the addition/deduction into the right collection
            switch (this.workoutDeductionType(savedAdditionsAndDeduction)) {
              case 'preTaxAdditions':
                timesheetRecord.preTaxAdditions.push(savedAdditionsAndDeduction);
                break;
              case 'postTaxAdditions':
                timesheetRecord.postTaxAdditions.push(savedAdditionsAndDeduction);
                break;
              case 'preTaxDeductions':
                timesheetRecord.preTaxDeductions.push(savedAdditionsAndDeduction);
                break;
              case 'postTaxDeductions':
                timesheetRecord.postTaxDeductions.push(savedAdditionsAndDeduction);
                break;
            }

          });

          // Already authorised or submitted
          if (this.isAuthorising) {
            timesheetRecord.submit_for_auth = !this.isAuthorisedToEdit(timesheetRecord);
          }
          else if (this.isSubmitting) {
            timesheetRecord.submit_to_genius = !this.isAuthorisedToEdit(timesheetRecord);
          }

          // Trigger any required calculations
          this.changeTimesheetValues(timesheetRecord);

        });

        // Orders
        timesheetAuthorisation.order_jobs.forEach(orderJob => {
          // Week
          this.week.forEach((day, index) => {
            // Descriptions are now always available
            if (typeof orderJob.timesheet_info[index] !== 'undefined') {
              orderJob.workLog[index].description = orderJob.timesheet_info[index].day_desc;
            }
          });
        });
      });
    },
    setFlags() {
      this.isSubmitting = this.$store.state.auth.me.roles.includes('client_sub');
      this.isAuthorising = this.$store.state.auth.me.roles.includes('client_auth');
      this.isPayroll = (this.crmType === 'payroll')
      this.isRecruitment = (this.crmType === 'recruitment');
      this.isPayrollEnabled = (this.isPayroll || this.isRecruitment && !this.$store.state.auth.me.recruitment);
      this.isRecruitmentEnabled = (this.isRecruitment && this.$store.state.auth.me.recruitment)
    },
    getLocationName(timesheetAuthorisation) {
      return timesheetAuthorisation.location;
    },
    getSubmittedWorkers(timesheetAuthorisation) {
      let submitted = 0;
      timesheetAuthorisation.ts_records.forEach(timesheet => {
        if (timesheet.worker_submitted) {
          submitted++;
        }
      });

      return submitted;
    },
    getTotalWorkers(timesheetAuthorisation) {
      return timesheetAuthorisation.ts_records.length;
    },
    isApproved(timesheetRecord) {
      return (timesheetRecord.auth_level >= 8);
    },
    getWorkerFirstName(timesheetRecord) {
      return timesheetRecord.assignment.worker.person.first_name;
    },
    getWorkerSurname(timesheetRecord) {
      return timesheetRecord.assignment.worker.person.surname;
    },
    getWorkerNameSurname(timesheetRecord) {
      let workerName = '';
      let companyName = null;
      workerName += timesheetRecord.assignment.worker.person.first_name;
      workerName += " ";
      workerName += timesheetRecord.assignment.worker.person.surname;

      if (this.companyData && this.companyData.rel_profile.show_worker_company_name) {
        companyName = timesheetRecord.assignment.worker.rel_company_info.company_trading_name;
      }

      companyName = companyName ?? workerName;
      return companyName;
    },
    async loadCompanyData() {

      if (this.$store.state.client_info.info) {
        this.companyData = this.$store.state.client_info.info;
        return;
      }

      const response = await axios.get(this.crmApiPath + 'contact/' + this.$store.state.auth.me.contact_id + '/company/show');
      this.companyData = response.data;
      this.$store.commit('SAVE_CLIENT_INFO', {
        data: response.data
      });

    },
    timesheetStatusClass(timesheetRecord) {
      if (this.isApproved(timesheetRecord)) {
        return 'ready';
      }

      if (timesheetRecord.worker_submitted || this.getTotalUnits(timesheetRecord) > 0) {
        return 'worker-ready';
      }

      return '';
    },
    determineButtonText(timesheetAuthorisation) {
      if (this.allApproved()) {
        return 'Unlock';
      }

      return 'Approve & Lock';
    },
    allApproved() {
      let approved = 0;
      this.timesheetAuthorisation.ts_records.forEach(timesheet => {
        if (this.isApproved(timesheet)) {
          approved++;
        }
      });

      return this.timesheetAuthorisation.ts_records.length === approved;
    },
    changeLocationStatus(status) {
      this.$emit('location-status-changed', { locationId: this.locationData.location_id, status: status });
    },
    getReferenceNumber(timesheetRecord) {
      // check employment status of worker and if they have a company ref number
      // (if limited company use company_internal_finance_ref)
      if (timesheetRecord.assignment.worker.rel_company_info.employment_type_id === 32 && timesheetRecord.assignment.worker.rel_company_info.company_internal_finance_ref !== null) {
        return timesheetRecord.assignment.worker.rel_company_info.company_internal_finance_ref
      }
      // if not limited company use worker_internal_finance_ref
      return timesheetRecord.assignment.worker.internal_finance_ref
    },
    getGangMember(timesheetRecord) {
      if (timesheetRecord.assignment.is_gang_leader) {
        return '<i class="fas fa-crown text-warning"></i> Gang Leader';
      }
      if (timesheetRecord.assignment.gang_leader_id) {
        return '<i class="fas fa-people-arrows text-secondary"></i> ' + timesheetRecord.assignment.gang_leader.person.surname + "'s gang";
      }
      return '';
    },

    getWorkerJobTitle(timesheetRecord) {
      return timesheetRecord.assignment.order_job.rel_order_position.job_title;
    },
    getWorkerPayRateType(timesheetRecord) {
      return timesheetRecord.assignment.position_rate.pay_type + '/' + timesheetRecord.assignment.position_rate.rate_type;
    },
    getWorkerPayRate(timesheetRecord) {
      if (timesheetRecord.assignment.order_job.order.order_type === 'Payroll - PAYE' ||
        timesheetRecord.assignment.order_job.order.order_type === 'Temporary (PAYE)'
      ) {
        return timesheetRecord.assignment.position_rate.admin_fee_amount;
      }
      else {
        return timesheetRecord.assignment.position_rate.pay_amount;
      }
    },
    getWorkerPayRateAdminFeeAmount(timesheetRecord) {
      if (
        timesheetRecord.assignment.worker.rel_company_info.employment_type_id === 33 // 33 - PAYE
      ) {
        // return timesheetRecord.assignment.position_rate.admin_fee_amount;
        return this.$options.filters.currency(timesheetRecord.assignment.position_rate.admin_fee_amount);
      } else {
        return 'N/A';
      }
    },
    getTotalUnits(timesheetRecord) {
      return timesheetRecord.week.reduce((a, b) => a + b, 0);
    },
    getTotalBeforeAdditionsAndDeductions(timesheetRecord) {
      return this.getTotalUnits(timesheetRecord) * this.getWorkerPayRate(timesheetRecord);
    },
    getReleaseRetentionPercentage(timesheetRecord) {
      return timesheetRecord.assignment.position_rate.retention_percentage;
    },
    getReleaseRetentionAmount(timesheetRecord) {
      if (this.getTotalBeforeAdditionsAndDeductions(timesheetRecord) !== 0 && !timesheetRecord.retention_released) {
        return parseFloat(this.getTotalBeforeAdditionsAndDeductions(timesheetRecord)) * (parseFloat(this.getReleaseRetentionPercentage(timesheetRecord)) / 100);
      }
      return 0;
    },
    getPreTaxAdditions(timesheetRecord) {
      return timesheetRecord.preTaxAdditions;
    },
    getPostTaxAdditions(timesheetRecord) {
      return timesheetRecord.postTaxAdditions;
    },
    getPreTaxDeductions(timesheetRecord) {
      return timesheetRecord.preTaxDeductions;
    },
    getPostTaxDeductions(timesheetRecord) {
      return timesheetRecord.postTaxDeductions;
    },
    getPreTaxAdditionsAmount(timesheetRecord) {
      let amount = 0;
      this.getPreTaxAdditions(timesheetRecord).forEach(submission => {
        amount += parseFloat(submission.amount);
      });
      return amount;
    },
    getPostTaxAdditionsAmount(timesheetRecord) {
      let amount = 0;
      this.getPostTaxAdditions(timesheetRecord).forEach(submission => {
        amount += parseFloat(submission.amount);
      });
      return amount;
    },
    getPreTaxDeductionsAmount(timesheetRecord) {
      let amount = 0;
      this.getPreTaxDeductions(timesheetRecord).forEach(submission => {
        amount += parseFloat(submission.amount);
      });
      return amount;
    },
    getPostTaxDeductionsAmount(timesheetRecord) {
      let amount = 0;
      this.getPostTaxDeductions(timesheetRecord).forEach(submission => {
        amount += parseFloat(submission.amount);
      });
      return amount;
    },
    getInvoiceTotal(timesheetRecord) {
      let invoiceAmount = 0;

      invoiceAmount += this.getTotalBeforeAdditionsAndDeductions(timesheetRecord);

      // Additions
      invoiceAmount += this.getPreTaxAdditionsAmount(timesheetRecord);
      invoiceAmount += this.getPostTaxAdditionsAmount(timesheetRecord);

      // Deductions
      invoiceAmount -= this.getPreTaxDeductionsAmount(timesheetRecord);
      invoiceAmount -= this.getPostTaxDeductionsAmount(timesheetRecord);

      // set values for check logic
      if (invoiceAmount > 0) {
        this.invoiceAmountCheck = true;
      }

      return invoiceAmount;
    },
    getAuthoriseWith(timesheetRecord) {
      if (timesheetRecord.auth_with === 'crm') {
        if (this.crmType === 'payroll') {
          return 'Genius';
        }
        else if (this.crmType === 'recruitment') {
          return 'V3';
        }
      }

      if (timesheetRecord.auth_with === null) {
        return 'You';
      }

      return timesheetRecord.auth_with.first_name + ' ' + timesheetRecord.auth_with.surname;
    },

    /**
     * Pre-populate worker hours from GeoTech (if any) otherwise use default values.
     * @param {*} ts
     * @param {*} index 
     */
    setWorkerHours(ts, index) {
      
      if (!(index in ts.timesheet_pay)) {
        console.warn('Payment not exists for timesheet: ' + ts.id);
        return;
      }

      let amount = 0;
      let payType = ts.assignment.position_rate.pay_type;

      if (payType === 'Price') {
        amount = ts.timesheet_pay[index].price;
      } else {
        amount = ts.timesheet_pay[index].hours_total
      }

      if (amount > 0) {
        ts.week[index] = amount;
        return;
      }
    },
    inputClass(type) {
      if (type === "S") {
        return 'bg-red';
      } else if (type === "H") {
        return 'bg-yellow';
      } else if (type === "M") {
        return 'bg-blue';
      }
    },
    setAbsence(type, index, recordIndex) {
      // if the absence type is already selected
      if (this.timesheetAuthorisation.ts_records[recordIndex].timesheet_pay[index].absence_type === type) {
        this.timesheetAuthorisation.ts_records[recordIndex].timesheet_pay[index].absence_type = null;
        this.timesheetAuthorisation.ts_records[recordIndex].week[index] = 0;
      } else {
        this.timesheetAuthorisation.ts_records[recordIndex].timesheet_pay[index].absence_type = type;
        this.timesheetAuthorisation.ts_records[recordIndex].week[index] = 0;
      }

      this.forceUpdate();
    },
    resetAbsence(recordIndex) {
      for (let i = 0; i < this.timesheetAuthorisation.ts_records[recordIndex].timesheet_pay.length; i++) {
        this.timesheetAuthorisation.ts_records[recordIndex].timesheet_pay[i].absence_type = null;
      }
    },

    /***********************************************************************
     *  Column Totals
     ***********************************************************************/

    sumOfDays(timesheetAuthorisation, targetIndex) {
      let total = 0;

      timesheetAuthorisation.ts_records.forEach(timesheetRecord => {
        timesheetRecord.week.forEach((hours, index) => {
          if (index === targetIndex) {
            total += hours;
          }
        });
      });

      return total;
    },
    sumOfTotalUnits(timesheetAuthorisation) {
      let total = 0;

      timesheetAuthorisation.ts_records.forEach(timesheetRecord => {
        total += this.getTotalUnits(timesheetRecord);
      });

      return total;
    },
    sumOfTotalBeforeAdditionsAndDeductions(timesheetAuthorisation) {
      let total = 0;

      timesheetAuthorisation.ts_records.forEach(timesheetRecord => {
        total += this.getTotalBeforeAdditionsAndDeductions(timesheetRecord);
      });

      return total;
    },
    sumOfReleaseRetentionAmount(timesheetAuthorisation) {
      let total = 0;

      timesheetAuthorisation.ts_records.forEach(timesheetRecord => {
        total += this.getReleaseRetentionAmount(timesheetRecord);
      });

      return total;
    },
    sumOfPreTaxAdditionsAmount(timesheetAuthorisation) {
      let total = 0;

      timesheetAuthorisation.ts_records.forEach(timesheetRecord => {
        total += this.getPreTaxAdditionsAmount(timesheetRecord);
      });

      return total;
    },
    sumOfPostTaxAdditionsAmount(timesheetAuthorisation) {
      let total = 0;

      timesheetAuthorisation.ts_records.forEach(timesheetRecord => {
        total += this.getPostTaxAdditionsAmount(timesheetRecord);
      });

      return total;
    },
    sumOfPreTaxDeductionsAmount(timesheetAuthorisation) {
      let total = 0;

      timesheetAuthorisation.ts_records.forEach(timesheetRecord => {
        total += this.getPreTaxDeductionsAmount(timesheetRecord);
      });

      return total;
    },
    sumOfPostTaxDeductionsAmount(timesheetAuthorisation) {
      let total = 0;

      timesheetAuthorisation.ts_records.forEach(timesheetRecord => {
        total += this.getPostTaxDeductionsAmount(timesheetRecord);
      });

      return total;
    },
    sumOfInvoiceTotal(timesheetAuthorisation) {
      let total = 0;

      timesheetAuthorisation.ts_records.forEach(timesheetRecord => {
        total += this.getInvoiceTotal(timesheetRecord);
      });

      return total;
    },

    /***********************************************************************
     *  Additions and Deductions UI
     ***********************************************************************/

    addPreTaxAddition(timesheet) {
      timesheet.preTaxAdditions.push({
        "id": 0,
        "ts_record_id": timesheet.id,
        "amount": 0,
        "desc": this.timesheetPreTaxAdditionsOptions[0]
      });
      this.closePreview();
      this.changeTimesheetValues(timesheet);
      this.forceUpdate();
    },
    addPostTaxAddition(timesheet) {
      timesheet.postTaxAdditions.push({
        "id": 0,
        "ts_record_id": timesheet.id,
        "amount": 0,
        "desc": this.timesheetPostTaxAdditionsOptions[0]
      });
      this.closePreview();
      this.changeTimesheetValues(timesheet);
      this.forceUpdate();
    },
    addPreTaxDeduction(timesheet) {
      timesheet.preTaxDeductions.push({
        "id": 0,
        "ts_record_id": timesheet.id,
        "amount": 0,
        "desc": this.timesheetPreTaxDeductionsOptions[0]
      });
      this.closePreview();
      this.changeTimesheetValues(timesheet);
      this.forceUpdate();
    },
    addPostTaxDeduction(timesheet) {
      timesheet.postTaxDeductions.push({
        "id": 0,
        "ts_record_id": timesheet.id,
        "amount": 0,
        "desc": this.timesheetPostTaxDeductionsOptions[0]
      });
      this.closePreview();
      this.changeTimesheetValues(timesheet);
      this.forceUpdate();
    },
    removePreTaxAddition(submission, timesheet) {
      let index = timesheet.preTaxAdditions.indexOf(submission);
      timesheet.preTaxAdditions.splice(index, 1);
      this.closePreview();
      this.changeTimesheetValues(timesheet);
      this.forceUpdate();
    },
    removePostTaxAddition(submission, timesheet) {
      let index = timesheet.postTaxAdditions.indexOf(submission);
      timesheet.postTaxAdditions.splice(index, 1);
      this.closePreview();
      this.changeTimesheetValues(timesheet);
      this.forceUpdate();
    },
    removePreTaxDeduction(submission, timesheet) {
      let index = timesheet.preTaxDeductions.indexOf(submission);
      timesheet.preTaxDeductions.splice(index, 1);
      this.closePreview()
      this.changeTimesheetValues(timesheet);
      this.forceUpdate();
    },
    removePostTaxDeduction(submission, timesheet) {
      let index = timesheet.postTaxDeductions.indexOf(submission);
      timesheet.postTaxDeductions.splice(index, 1);
      this.closePreview();
      this.changeTimesheetValues(timesheet);
      this.forceUpdate();
    },

    /***********************************************************************
     *  Summary Info Fields
     ***********************************************************************/

    getSummaryOrderRef(orderJob) {
      return orderJob.order_ref;
    },
    getSummaryJobTitle(orderJob) {
      return orderJob.rel_order_position.job_title;
    },
    getSummarySupervisorName(orderJob) {
      return orderJob.rel_order_position.reports_to_contact.person.first_name + ' ' + orderJob.rel_order_position.reports_to_contact.person.surname;
    },

    /***********************************************************************
     *  Preview Fields
     ***********************************************************************/

    isPreviewWorkerSubmitted(workerReference) {
      let workerSubmitted = false;

      // Find anywhere that this worker has been submitted to see if we need to show their row
      let timesheetAuthorisations = this.timesheetAuthorisations;
      if (timesheetAuthorisations.length > 0) {
        timesheetAuthorisations.forEach(timesheetAuthorisation => {
          timesheetAuthorisation.ts_records.forEach(timesheetRecord => {

            // We only want to check timesheets that have been submitted
            if (
              // Timesheet has been submitted AND...
              (timesheetRecord.submit_to_genius || timesheetRecord.submit_for_auth) &&

              // Worker has been found
              (timesheetRecord.assignment.worker.id === workerReference.id)
            ) {
              workerSubmitted = true;
            }
          });
        });
      }

      return workerSubmitted;
    },
    getPreviewWorkerFullName(worker) {
      return worker.person.first_name + ' ' + worker.person.surname;
    },
    getPreviewWorkerTotalBeforeAdditionsAndDeductions(worker, timesheetAuthorisation) {
      // Only get the timesheet that this worker is on
      let timesheetRecords = timesheetAuthorisation.ts_records.filter(timesheetRecord => {
        return timesheetRecord.assignment.worker.id === worker.id;
      });

      if (timesheetRecords.length === 0) {
        return 0;
      }

      // Select the first timesheet records
      let timesheetRecord = timesheetRecords[0];

      return this.getTotalBeforeAdditionsAndDeductions(timesheetRecord);
    },
    getPreviewWorkerPreTaxAddition(worker) {
      let total = 0;

      let timesheets = this.getPreviewAllWorkerTimesheets(worker);
      timesheets.forEach(timesheet => {
        total += this.getPreTaxAdditionsAmount(timesheet);
      });

      return total;
    },
    getPreviewWorkerPostTaxAddition(worker) {
      let total = 0;

      let timesheets = this.getPreviewAllWorkerTimesheets(worker);
      timesheets.forEach(timesheet => {
        total += this.getPostTaxAdditionsAmount(timesheet);
      });

      return total;
    },
    getPreviewWorkerPreTaxDeduction(worker) {
      let total = 0;

      let timesheets = this.getPreviewAllWorkerTimesheets(worker);
      timesheets.forEach(timesheet => {
        total += this.getPreTaxDeductionsAmount(timesheet);
      });

      return total;
    },
    getPreviewWorkerPostTaxDeduction(worker) {
      let total = 0;

      let timesheets = this.getPreviewAllWorkerTimesheets(worker);
      timesheets.forEach(timesheet => {
        total += this.getPostTaxDeductionsAmount(timesheet);
      });

      return total;
    },
    getPreviewWorkerInvoiceTotal(worker) {
      let total = 0;

      let timesheets = this.getPreviewAllWorkerTimesheets(worker);
      timesheets.forEach(timesheetRecord => {

        total += this.getInvoiceTotal(timesheetRecord);

      });

      return total;
    },
    getPreviewSumOfTotalBeforeAdditionsAndDeductions(timesheetAuthorisation) {
      return this.sumOfTotalBeforeAdditionsAndDeductions(timesheetAuthorisation);
    },
    getPreviewSumOfPreTaxAddition() {
      let total = 0;
      this.timesheetAuthorisations.forEach(timesheetAuthorisation => {
        total += this.sumOfPreTaxAdditionsAmount(timesheetAuthorisation);
      });
      return total;
    },
    getPreviewSumOfPostTaxAddition() {
      let total = 0;
      this.timesheetAuthorisations.forEach(timesheetAuthorisation => {
        total += this.sumOfPostTaxAdditionsAmount(timesheetAuthorisation);
      });
      return total;
    },
    getPreviewSumOfPreTaxDeduction() {
      let total = 0;
      this.timesheetAuthorisations.forEach(timesheetAuthorisation => {
        total += this.sumOfPreTaxDeductionsAmount(timesheetAuthorisation);
      });
      return total;
    },
    getPreviewSumOfPostTaxDeduction() {
      let total = 0;
      this.timesheetAuthorisations.forEach(timesheetAuthorisation => {
        total += this.sumOfPostTaxDeductionsAmount(timesheetAuthorisation);
      });
      return total;
    },
    getPreviewSumOfInvoiceTotal() {
      let total = 0;
      this.timesheetAuthorisations.forEach(timesheetAuthorisation => {
        total += this.sumOfInvoiceTotal(timesheetAuthorisation);
      });
      return total;
    },

    /***********************************************************************
     *  Rate and Assignment functions
     ***********************************************************************/

    show_ts_assign_worker_modal(timesheetAuthorisation, location) {
      this.saveTimesheetSilently('save_timesheet');
      this.$store.commit('SHOW_ASSIGN_WORKER_MODAL', {
        company_id: timesheetAuthorisation.ts_records[0].company_id,
        timesheet_order_jobs: timesheetAuthorisation.order_jobs,
        location: location,
        for_work_end_week_date: this.$moment.utc(this.timesheetAuthorisation['ts_records'][0]['for_work_end_week_date']).format('YYYY-MM-DD')
      })
      this.$nextTick(() => this.$root.$emit('bv::show::modal', 'ts_assign_worker_modal'));
    },

    is_invoice_total_zero(timesheetRecord) {
      return this.getInvoiceTotal(timesheetRecord) === 0;
    },
    get_timesheet_worker_invoice_details_description(details) {
      return details && details.timesheet_worker_invoice_details
        ? details.timesheet_worker_invoice_details.description
        : '';
    },

    show_ts_rates_worker_modal(timesheetRecord, timesheetAuthorisation) {
      this.saveTimesheetSilently('save_timesheet')
      this.$store.commit('SHOW_RATE_WORKER_MODAL', {
        current_assignment: timesheetRecord.assignment,
        order_location: this.getLocationName(timesheetAuthorisation),
        for_work_end_week_date: timesheetRecord.for_work_end_week_date,
        ts_record_id: timesheetRecord.id
      })
      this.$nextTick(() => this.$root.$emit('bv::show::modal', 'ts_rate_change_modal'));
    },

    remove_timesheet_record(timesheet_record_id) {
      return new Promise(resolve => {
        // loop through timesheetAuthorisations (array)
        for (let i = 0; i < this.timesheetAuthorisations.length; i++) {
          // loop through ts_records (array)
          this.timesheetAuthorisations[i].ts_records.forEach(function (item, index, object) {
            // if timesheet record with passed id found then remove from the array
            if (item.id === timesheet_record_id) {
              object.splice(index, 1)
            }
          })
        }
        resolve();
      })

    },

    /***********************************************************************
     *  TODOitem functions
     ***********************************************************************/

    addTodoItem(todo) {
      todo.push(
        { id: 1, description: "", completed: false }
      );
    },
    removeTodoItem(item, todo) {
      this.$snotify.confirm('', '', {
        closeOnClick: false,
        position: 'centerCenter',
        backdrop: 0.5,
        html: '<div class="snotifyToast__title">Are you sure?</div>' +
          '<div class="snotifyToast__body">' +
          'Are you sure you want to mark this task as done and remove it from the list?' +
          '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
          '</div>',
        buttons: [
          {
            text: 'OK', action: (toast) => {
              let index = todo.indexOf(item);
              todo.splice(index, 1);
              this.$snotify.remove(toast.id);
            }
          },
          { text: 'Cancel', action: (toast) => this.$snotify.remove(toast.id) }
        ]
      });
    },

    /***********************************************************************
     *  Utility functions
     ***********************************************************************/

    zIndexReverse(total, index) {
      let style = 'z-index: ' + ((10 + total) - index) + ';';

      if (total / (index + 1) === 2) {
        style += 'padding-right: 70px;';
      }

      return style;
    },
    closeOtherAccordions() {
      // Fetch all the details element.
      const details = document.querySelectorAll("details");

      details.forEach((targetDetail) => {
        targetDetail.removeAttribute("open");
      });
    },
    isInvoiceAvailable(timesheetRecord) {
      return (timesheetRecord.timesheet_worker_invoice !== null);
    },
    showInvoiceSummary(timesheetRecord) {
      this.$store.commit('SHOW_INVOICE_MODAL', {
        first_name: this.getWorkerFirstName(timesheetRecord),
        surname: this.getWorkerSurname(timesheetRecord),
        invoice: timesheetRecord
      });
      this.$nextTick(() => this.$root.$emit('bv::show::modal', 'show_invoice_modal'));
    },
    workoutDeductionType(savedAdditionsAndDeduction) {
      // Check the ID against the various collections of CRM objects
      let id = savedAdditionsAndDeduction.desc.id;

      // Pre Tax Additions
      let matched = this.timesheetPreTaxAdditionsOptions.filter(object => {
        return object.id === id
      });
      if (matched.length > 0) {
        return 'preTaxAdditions';
      }
      // matched = this.timesheetPreTaxAdditionsOptionsAll.filter(object => {
      //   return object.id === id
      // });
      // if (matched.length > 0) {
      //   return 'preTaxAdditions';
      // }

      // Post Tax Additions
      matched = this.timesheetPostTaxAdditionsOptions.filter(object => {
        return object.id === id
      });
      if (matched.length > 0) {
        return 'postTaxAdditions';
      }
      // matched = this.timesheetPostTaxAdditionsOptionsAll.filter(object => {
      //   return object.id === id
      // });
      // if (matched.length > 0) {
      //   return 'postTaxAdditions';
      // }

      // Pre Tax Deductions
      matched = this.timesheetPreTaxDeductionsOptions.filter(object => {
        return object.id === id
      });
      if (matched.length > 0) {
        return 'preTaxDeductions';
      }
      // matched = this.timesheetPreTaxDeductionsOptionsAll.filter(object => {
      //   return object.id === id
      // });
      // if (matched.length > 0) {
      //   return 'preTaxDeductions';
      // }

      // Post Tax Deductions
      matched = this.timesheetPostTaxDeductionsOptions.filter(object => {
        return object.id === id
      });
      if (matched.length > 0) {
        return 'postTaxDeductions';
      }
      // matched = this.timesheetPostTaxDeductionsOptionsAll.filter(object => {
      //   return object.id === id
      // });
      // if (matched.length > 0) {
      //   return 'postTaxDeductions';
      // }

    },
    getPreviewAllWorkerTimesheets(worker) {
      let timesheets = [];

      // Find anywhere that this worker has been submitted to see if we need to show their row
      if (this.timesheetAuthorisations.length > 0) {
        this.timesheetAuthorisations.forEach(timesheetAuthorisation => {
          timesheetAuthorisation.ts_records.forEach(timesheetRecord => {

            if (timesheetRecord.assignment.worker.id === worker.id) {
              timesheets.push(timesheetRecord);
            }

          });
        });
      }

      return timesheets;
    },
    submitAllWorkersInLocation() {
      if (this.allApproved()) {
        this.unapprove();
      } else {
        this.approve();
      }
    },
    canSaveButton() {
      if (this.allApproved()) {
        return false;
      } else {
        return true;
      }
    },
    saveAllWorkersInLocation() {
      if (!this.allApproved()) {
        this.setSubmitFlags(false);
        this.saveTimesheet("save_timesheet");
      }
    },
    approve() {
      this.$snotify.confirm('', '', {
        closeOnClick: false,
        position: 'centerCenter',
        backdrop: 0.5,
        html: '<div class="snotifyToast__title">Are you sure?</div>' +
          '<div class="snotifyToast__body">' +
          'Are you sure you would like to approve timesheet for all workers on this site?' +
          '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
          '</div>',
        buttons: [
          {
            text: 'OK', action: (toast) => {
              this.setSubmitFlags(true);
              this.saveTimesheet("save_timesheet_approve");
              this.$snotify.remove(toast.id);
            }
          },
          { text: 'Cancel', action: (toast) => this.$snotify.remove(toast.id) }
        ]
      });
    },
    unapprove() {
      this.$snotify.confirm('', '', {
        closeOnClick: false,
        position: 'centerCenter',
        backdrop: 0.5,
        html: '<div class="snotifyToast__title">Are you sure?</div>' +
          '<div class="snotifyToast__body">' +
          'Are you sure you would like to unapprove timesheet for all workers on this site?' +
          '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
          '</div>',
        buttons: [
          {
            text: 'OK', action: (toast) => {
              this.setSubmitFlags(false);
              this.saveTimesheet("unlock_timesheet");
              this.$snotify.remove(toast.id);
            }
          },
          { text: 'Cancel', action: (toast) => this.$snotify.remove(toast.id) }
        ]
      });
    },
    setSubmitFlags(flag) {
      this.timesheetAuthorisation.ts_records.forEach((timesheet) => {

        this.location_data.auth_level = flag === true ? 8 : 0;
        timesheet.auth_level = flag === true ? 8 : 0;

        if (this.isSubmitting) {
          timesheet.submit_to_genius = flag;
        }
        else if (this.isAuthorising) {
          timesheet.submit_for_auth = flag;
        }

      });
    },
    toggleLocationInformation(timesheetAuthorisation) {
      timesheetAuthorisation.showLocationInformation = !timesheetAuthorisation.showLocationInformation;
      this.forceUpdate();
    },
    toggleReminderInformation(timesheetAuthorisation) {
      timesheetAuthorisation.showReminderInformation = !timesheetAuthorisation.showReminderInformation;
      this.forceUpdate();
    },
    toggleOrderJobFields(orderJob) {
      orderJob.showFields = !orderJob.showFields;
      this.forceUpdate();
    },
    togglePreview() {
      this.showPreview = !this.showPreview;
      this.forceUpdate();
    },
    changeTimesheetDay(index, dayIndex, timesheetRecord) {
      this.invoiceAmountCheck = false;
      this.closePreview();

      if (this.timesheetAuthorisation.ts_records[index].week[dayIndex] != 0) {
        this.timesheetAuthorisation.ts_records[index].timesheet_pay[dayIndex].absence_type = null;
      };

      let hours = parseFloat(timesheetRecord.week[dayIndex]);
      if (isNaN(hours)) {
        hours = 0;
        timesheetRecord.week[dayIndex] = hours;
      }

      this.changeTimesheetValues(timesheetRecord);
      this.$emit('location-preview-reload');
    },
    changeAdditionAndDeductionValue(selection) {
      this.closePreview();

      let amount = parseFloat(selection.amount);
      if (isNaN(amount)) amount = 0;

      selection.amount = amount;
    },
    changeTimesheetValues(timesheetRecord) {
      this.closePreview();
      timesheetRecord.total_hours = this.getTotalUnits(timesheetRecord);
      timesheetRecord.total_price = this.getTotalBeforeAdditionsAndDeductions(timesheetRecord);
      timesheetRecord.total_additions = this.getPreTaxAdditionsAmount(timesheetRecord) + this.getPostTaxAdditionsAmount(timesheetRecord);
      timesheetRecord.total_deductions = this.getPreTaxDeductionsAmount(timesheetRecord) + this.getPostTaxDeductionsAmount(timesheetRecord);
      timesheetRecord.total_pay_amount = this.getInvoiceTotal(timesheetRecord);
      timesheetRecord.retention_amount = this.getReleaseRetentionAmount(timesheetRecord);
    },
    closePreview() {
      this.showPreview = false;
      this.forceUpdate();
    },
    isAuthorisedToEdit(timesheetRecord) {
      return (timesheetRecord.auth_level === 0 || timesheetRecord.auth_level < this.timesheetAuthorisation.auth_level);
    },
    recalculateAll() {
      this.timesheetAuthorisation.ts_records.forEach(timesheet => {
        this.changeTimesheetValues(timesheet);
      });
    },
    saveTimesheet(apiFunction) {
      this.loading = true;
      this.loadingMessage = 'Saving ...';
      this.$emit('saving-location', true);
      this.recalculateAll();
      this.saveTimesheetSilently(apiFunction).then(() => {

        if (apiFunction === 'save_timesheet' || apiFunction === 'save_timesheet_approve') {
          this.closeLocation();
        } else {
          this.resetTimesheets();
        }

        // Change the approved/unapproved message
        if (apiFunction === 'save_timesheet') {
          this.$emit('location-preview-reload');
        } else if (apiFunction === 'save_timesheet_approve') {
          this.changeLocationStatus(true);
        } else if (apiFunction === 'unlock_timesheet') {
          this.changeLocationStatus(false);
        }

        this.$emit('saving-location', false);
        this.loading = false;
        this.forceUpdate();
      });
    },
    saveTimesheetSilently(apiFunction) {
      return axios.post(this.crmApiPath + 'timesheet/' + apiFunction, {
        'submission': this.timesheetAuthorisation,
        'submission_date': this.submissionDate,
        'contact_id': this.$store.state.auth.me.contact_id,
        'contact_email': this.$store.state.auth.me.email,
        'contact_name': this.$store.state.auth.me.first_name,
        'company_name': this.companyName,
        'company_id': this.company_id,
        'is_recruitment_enabled': this.isRecruitmentEnabled,
        'is_payroll_enabled': this.isPayrollEnabled,
        'is_submitting': this.isSubmitting,
        'is_authorising': this.isAuthorising
      });
    },
    dispatchTimesheets() {
      // this was used for child components
      return;
    },
    closeLocation() {
      const details = document.querySelectorAll("details");
      details.forEach((detail) => {
        detail.removeAttribute("open");
      });
    },
    resetTimesheets() {
      this.timesheetAuthorisation.ts_records.forEach(timesheet => {
        timesheet.auth_level = 0;
        timesheet.company_submitted = 0;
      });
    },
    /***********************************************************************
     *  Vue Lifecycle functions
     ***********************************************************************/

    forceUpdate() {
      this.$forceUpdate();
    }
  }
}
</script>